import Vue from "vue";
import Vuex from "vuex";
import { axiosBase, getAPI } from "@/api/axios-base";
import router from "@/router/index";
import { ResponseStatus } from "@/models/ResponseStatusEnum";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    accessToken: localStorage.getItem("access_token") || null, // makes sure the user is logged in even after
    refreshToken: localStorage.getItem("refresh_token") || null,
    sidebarSelected: localStorage.getItem("sidebar_selected") || null,
    profile:
      localStorage.getItem("profile") != null
        ? JSON.parse(localStorage.getItem("profile") || "")
        : null
    // student: JSON.parse(JSON.parse(localStorage.getItem("student") || "{}")) || null,
  },
  getters: {
    loggedIn(state: any) {
      return state.accessToken != null;
    },
    someSelected(state: any) {
      return state.sidebarSelected != null;
    },
    sidebarSelected: (state: any) => state.sidebarSelected,
    username: (state: any) => state.profile.name,
    userRole: (state: any) => state.profile.role
  },
  mutations: {
    // USER MUTATION
    updateLocalStorage(state, { access, refresh }) {
      localStorage.setItem("access_token", access);
      localStorage.setItem("refresh_token", refresh);
      state.accessToken = access;
      state.refreshToken = refresh;
    },
    updateAccess(state, access) {
      state.accessToken = access;
      localStorage.setItem("access_token", access);
    },
    destroyToken(state) {
      state.accessToken = null;
      state.refreshToken = null;
      // state.profile = null;
      // state.student = null;
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("profile");
      // localStorage.removeItem("student");
    },
    updateProfile(state, profile) {
      state.profile = profile;
      localStorage.setItem("profile", JSON.stringify(profile));
    },
    updateSidebarSelected(state, item: string) {
      localStorage.setItem("sidebar_selected", item);
      state.sidebarSelected = item;
    }
  },
  actions: {
    // USER ACTIONS
    // run the below action to get a new access token on expiration
    async refreshToken(context) {
      const response = await getAPI.post("api/rest/v1/auth/refreshToken", {
        refreshToken: context.state.refreshToken
      });
      if (response.status === ResponseStatus.POST_OK) {
        context.commit("updateLocalStorage", {
          access: response.data.token,
          refresh: response.data.refreshToken
        }); // store the access and refresh token in localstorage
        context.commit("updateProfile", response.data.payload);
        return response.data.token;
      }
    },
    registerUser(_context, data) {
      return new Promise((resolve, reject) => {
        axiosBase
          .post("/register", {
            name: data.name,
            email: data.email,
            username: data.username,
            password: data.password,
            confirm: data.confirm
          })
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    logoutUser(context) {
      if (context.getters.loggedIn) {
        context.commit("destroyToken");
        router.push({ name: "auth" });
      }
    },
    async loginUser(context, credentials) {
      const response = await axiosBase.post("/api/rest/v1/auth/login", {
        email: credentials.email,
        password: credentials.password
      });
      if (response.status === ResponseStatus.POST_OK) {
        context.commit("updateLocalStorage", {
          access: response.data.token,
          refresh: response.data.refreshToken
        }); // store the access and refresh token in localstorage
        context.commit("updateProfile", response.data.payload);
      } else {
        // UNEXPECTED ERROR
        console.log(response);
      }
    },
    // END USER ACTIONS
    // SIDEBAR SELECT MENU
    setSidebarSelected(context, item: string) {
      context.commit("updateSidebarSelected", item);
    }
    // END SIDEBAR SELECT MENU
  }
});

// EXPORT TYPES
export { AppGetters } from "./app-getters.types";
